import { Group, GroupCreateRequest, GroupUpdateRequest } from '../../types/app/group.types';
import { api } from '../core/api';

export const getGroupList = () => api.get<Group[]>('Group/GetList').then((res) => res.data);

export const getGroup = (id: number) =>
  api.get<Group>(`Group/GetItem/?id=${id}`).then((res) => res.data);

export const updateGroup = (data: GroupUpdateRequest) =>
  api.put(`Group/UpdateItem`, data).then((res) => res.data);

export const createGroup = (data: GroupCreateRequest) =>
  api.post(`Group/CreateItem`, data).then((res) => res.data);

export const deleteGroup = (id: number) => api.delete<Group>(`Group/DeleteItem/?id=${id}`).then();
